var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"full-width"},[_c('div',{staticClass:"notification-header",class:[
         'header-' + _vm._uid,
         {
            'notification--confirmation': _vm.isConfirmation,
            'notification--alert': _vm.isAlert
         }
      ]},[_c('div',{staticClass:"notification__content",class:'content-' + _vm._uid},[_c('div',{staticClass:"notification__body"},[_vm._t("default",function(){return [_vm._v("\n               This is a\n               "),_c('strong',[_vm._v(_vm._s(_vm.type))]),_vm._v(" notification\n            ")]})],2),_c('button',{staticClass:"notification__close notification-cancel",attrs:{"aria-label":"Close"},on:{"click":function($event){return _vm.close()}}},[_c('i',{staticClass:"icon icon-022-close",attrs:{"aria-hidden":"true"}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }